export const calculateImpact = (impactValuation) => {
  const threatImpact = impactValuation;
  return threatImpact;
};
